export default __webpack_public_path__ + "static/media/liyulogo.2c886760.png";